import { cn } from '@/lib/utils'

import { DocumentPagination } from './document-pagination/document-pagination'

export interface DocumentHeaderProps {
  name: string
  currentPage: number
  totalPages: number
  onChangePage: (page: number) => void
}

export const DocumentHeader = ({ name, currentPage, totalPages, onChangePage }: DocumentHeaderProps) => {
  return (
    <div
      className={cn(
        'relative',
        'flex items-center justify-center',
        'w-full min-w-[780px]',
        'px-4 py-2',
        'bg-white',
        'rounded-[8px]'
      )}
    >
      <p className={cn('h-5', 'text-ellipsis text-sm font-semibold text-slate-900')}>{name}</p>
      <DocumentPagination currentPage={currentPage} totalPages={totalPages} onChangePage={onChangePage} />
    </div>
  )
}
